/* APPROVE business financing - 14 Oct 2026. Config: snippets/ctx-approve-config (window.CTX_APPROVE).
   Markup: snippets/ctx-approve-line ([data-ctx-approve] in the cart drawer + cart page),
   snippets/ctx-approve-pdp ([data-ctx-approve-pdp] in the product buy box, where the HSA button was),
   and any [data-ctx-approve-apply] button anywhere (invoice done panel, commercial financing page).

   SPEED: APPROVE's plugin is ~300KB. It is never loaded up front. The monthly estimate comes from
   APPROVE's own rate table (a 14KB settings file, cached for the session) using the plugin's own
   calculate_rate maths (verified 14 Oct: $18,000 -> $360.87/mo on their 72-month default, same as the
   plugin). The plugin itself loads on idle once a financing line is actually shown, or on first tap.

   WHO SEES IT. First rule (14 Oct): business-flagged shoppers only (Dillon: "not for home at all").
   Revised the same day (Dillon: someone adding more than $10k to their cart IS the commercial pattern):
   the lines now show whenever the amount reaches the threshold. Backed by a year of orders (Oct 2025 -
   Oct 2026, 809 orders): 55% of $10k+ orders carried a company name against 28% of all orders.

   BUSINESS SIGNALS (signals(), sent with invoice requests so sales sees why; also kept as a sticky flag,
   localStorage ctxBiz, for future commercial-only features). Each was checked against that export -
   share of orders showing it that had a company, vs the 28% base rate:
     cart $10k+ 55% | 5+ different items 51% | 2+ cardio machines 51% | company email domain (not
     gmail etc.) 46% | 2+ of the same machine 43%.
   BUILT's commercial lines (OG / Infinite series, BUILD pendulum, fixed barbell racks, deadlift
   platforms) were bought almost only by companies. Plus: a company name on the invoice form, a visit to
   /pages/commercial... or /collections/commercial..., a ?biz=1 link, or a signed-in business account.
   NOT signals: tax-free orders (29%, same as base) and a single cardio machine (29%).

   THRESHOLD: CTX_APPROVE.min dollars ($10,000 since 14 Oct). Cart: the cart total after discounts,
   before freight and tax. Product page: this item x quantity plus the rest of the cart.

   The drawer re-renders with innerHTML, so lines are found again by a MutationObserver, and clicks are
   delegated from document. */
(function () {
  'use strict';
  if (window.ctxApprove) return;
  var C = window.CTX_APPROVE || {};
  if (!C.id) return;
  var MIN = (C.min || 10000) * 100;
  var TEST = /[?&]invtest=1/.test(location.search) || !!(window.Shopify && Shopify.theme && Shopify.theme.role !== 'main');
  var HOOK = 'https://buildagym.app.n8n.cloud/webhook/bag-approve-event';

  function lsGet(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  function usd(n) { return '$' + Number(n).toLocaleString('en-US'); }

  /* ── business flag ── */
  if (/^\/(pages|collections)\/commercial/.test(location.pathname) || /[?&]biz=1\b/.test(location.search)) { lsSet('ctxBiz', '1'); lsSet('ctxBizPage', '1'); }
  try { var me = JSON.parse(lsGet('ctxInvMe') || 'null'); if (me && me.company) lsSet('ctxBiz', '1'); } catch (e) {}
  function isBiz() { return !!C.biz || lsGet('ctxBiz') === '1'; }

  /* ── monthly estimate from APPROVE's rate table ── */
  var setP = null;
  function settings() {
    if (setP) return setP;
    try { var c = JSON.parse(sessionStorage.getItem('ctxApproveCS') || 'null'); if (c && c.t > Date.now() - 6 * 3600e3) return (setP = Promise.resolve(c.d)); } catch (e) {}
    setP = fetch('https://plugin.approvepayments.com/plugin/core-settings/' + C.id).then(function (r) { return r.json(); }).then(function (j) {
      var g = (j.company && j.company.company_settings && j.company.company_settings.global_app) || {};
      var d = { rates: j.teaser_rates || [], fees: j.broker_fee_table || [], term: Number(g.lease_teaser_default_term) || 60, landing: j.finance_landing_page_url || C.landing };
      try { sessionStorage.setItem('ctxApproveCS', JSON.stringify({ t: Date.now(), d: d })); } catch (e) {}
      return d;
    });
    setP.catch(function () { setP = null; });
    return setP;
  }
  function monthly(d, dollars) {
    var fee = null, i;
    for (i = 0; i < d.fees.length; i++) { fee = d.fees[i]; if (dollars <= fee.value) break; }
    var amt = dollars * (1 + (fee ? Number(fee.rate_factor) : 0)), rate = null;
    for (i = 0; i < d.rates.length; i++) { var r = d.rates[i]; if (Number(r.rate_term) === d.term && amt >= r.min_value && amt < r.max_value) { rate = Number(r.rate_factor); break; } }
    return rate ? Math.round(amt * rate) : null;
  }
  function eligible(totalCents) { return Number(totalCents) >= MIN; }

  /* Business signals from the cart (and, when given, the invoice form) - see the header for the data. */
  var CARDIO = /treadmill|elliptical|bike|rower|stair|climber|arc trainer|cross ?trainer|skierg/i;
  var LOOSE = /dumbbell|kettlebell|plate(?![- ]?loaded)|bumper|barbell|band|collar|handle|attachment|bag care|warranty/i;
  var COMMERCIAL_LINE = /\bOG\b.{0,3}Series|Infinite Series|BUILD Pendulum|Fixed Barbell Rack|Deadlift Platform/i;
  var FREE_MAIL = /^(gmail|yahoo|aol|hotmail|icloud|outlook|live|msn|me|comcast|att|sbcglobal|verizon|protonmail|ymail|mac|bellsouth|charter|cox|rocketmail)\./i;
  function signals(cart, form) {
    var out = [], items = (cart && cart.items) || [], total = (cart && cart.total_price) || 0;
    if (total >= MIN) out.push('cart over ' + usd(Math.round(total / 100)));
    if (items.length >= 5) out.push(items.length + ' different items');
    var same = items.filter(function (i) { return i.quantity >= 2 && !LOOSE.test(i.product_title); });
    if (same.length) out.push(same[0].quantity + ' x ' + same[0].product_title.slice(0, 40));
    var cardio = items.filter(function (i) { return CARDIO.test(i.product_title); }).reduce(function (t, i) { return t + i.quantity; }, 0);
    if (cardio >= 2) out.push(cardio + ' cardio machines');
    if (items.some(function (i) { return COMMERCIAL_LINE.test(i.product_title); })) out.push('BUILT commercial line');
    if (form && form.company) out.push('company: ' + String(form.company).slice(0, 40));
    var dom = form && form.email ? String(form.email).split('@')[1] || '' : '';
    if (dom && !FREE_MAIL.test(dom)) out.push('company email (' + dom.slice(0, 40) + ')');
    if (C.biz) out.push('business account');
    if (lsGet('ctxBizPage') === '1') out.push('browsed commercial pages');
    return out;
  }
  /* Any cart-based signal makes the sticky business flag. */
  function noteCart(cart) {
    if (signals(cart).filter(function (x) { return !/business account|browsed/.test(x); }).length) lsSet('ctxBiz', '1');
  }
  /* 30 Oct 2026 (Dillon: financing must not show to residential customers, they can't get it): checkout can't read
     the company name without Shopify's protected-customer-data approval, so the site passes its own business signal
     along with the cart: cart attributes "Business buyer" = Yes and "Business signals" (they also show on the order,
     under Additional details, so sales sees why). STRICT signals only: everything in signals() EXCEPT a big cart on its
     own ("cart over $10k" - the pattern that also fits home gym builders). The checkout extension (checkout-guide,
     Business.jsx) shows financing only when this attribute, a company name, or a B2B account is present. */
  function strictSignals(cart) {
    var out = signals(cart).filter(function (x) { return !/^cart over/.test(x); });
    try { var me = JSON.parse(lsGet('ctxInvMe') || 'null'); if (me && me.company) out.push('company on invoice form'); } catch (e) {}
    return out;
  }
  function syncMark(cart) {
    if (!cart || !cart.items || !cart.items.length) return;
    var r = strictSignals(cart);
    if (!r.length) return;
    if ((cart.attributes || {})['Business buyer'] === 'Yes') return;
    try {
      fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { 'Business buyer': 'Yes', 'Business signals': r.join('; ').slice(0, 200) } }) }).catch(function () {});
    } catch (e) {}
  }
  var markT = null, markAt = 0;
  function markSoon(ms) {
    clearTimeout(markT);
    markT = setTimeout(function () {
      if (Date.now() - markAt < 5000) return;
      markAt = Date.now();
      cartJs(true).then(syncMark);
    }, ms || 1200);
  }
  function fill(el, totalCents) {
    settings().then(function (d) {
      var mo = monthly(d, totalCents / 100), t = el.querySelector('[data-ctx-approve-mo]');
      if (t) t.textContent = mo ? usd(mo) : '';
      if (!mo) { var p = el.querySelector('.ctx-fin__t'); if (p) p.innerHTML = '<strong>Business financing available</strong>'; }
    }).catch(function () {});
  }

  /* ── the plugin, on demand ── */
  var plugP = null;
  function plugin() {
    if (plugP) return plugP;
    plugP = new Promise(function (res, rej) {
      if (!document.querySelector('approve-plugin')) document.body.appendChild(document.createElement('approve-plugin'));
      var s = document.createElement('script');
      s.src = 'https://plugin.approvepayments.com/plugin/4.0/loader/' + C.id; s.async = true; s.onerror = function () { rej(new Error('load')); };
      document.head.appendChild(s);
      var n = 0;
      (function wait() {
        var a = window.kwipped_approve, ar = a && a.embedded_app && a.embedded_app.app_reference;
        if (ar && typeof ar.addItem === 'function') return res(ar);
        if (++n > 200) return rej(new Error('timeout'));
        setTimeout(wait, 100);
      })();
    });
    plugP.then(listen, function () { plugP = null; });
    return plugP;
  }
  function preload() {
    if (plugP) return;
    (window.requestIdleCallback || function (f) { setTimeout(f, 2500); })(function () { plugin().catch(function () {}); });
  }

  /* Conversion alert: Slack ping to Dillon + Klaviyo event (n8n "APPROVE application alerts"). */
  var listening = false;
  function listen(ar) {
    if (listening) return; listening = true;
    try { ar.setMinimizedIconHidden && ar.setMinimizedIconHidden(true); } catch (e) {}
    try {
      ar.addListener(function (m) {
        if (!m || m.action !== 'app_submitted') return;
        send({ action: 'app_submitted', route: m.route || '', customer: (m.data && m.data.customer) || {}, application: (m.data && m.data.application) || {}, items: (m.data && m.data.items) || [] });
      });
    } catch (e) {}
  }
  function send(o) {
    o.test = TEST; o.page = location.pathname;
    try { fetch(HOOK, { method: 'POST', body: new URLSearchParams({ d: JSON.stringify(o) }), keepalive: true }); } catch (e) {}
  }

  /* ── cart, cached briefly (the product page re-reads it on every quantity / variant change) ── */
  var cartP = null, cartAt = 0;
  function cartJs(fresh) {
    if (!cartP || fresh || Date.now() - cartAt > 8000) {
      cartAt = Date.now();
      cartP = fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) { noteCart(c); syncMark(c); return c; }).catch(function () { return { items: [] }; });
    }
    return cartP;
  }

  /* ── product page: the item being viewed, at the variant and quantity picked ── */
  function pdpItem(el) {
    var form = el.closest('form') || document;
    var idEl = form.querySelector('[name="id"]'), vid = String((idEl && idEl.value) || el.getAttribute('data-variant'));
    var map = {};
    (el.getAttribute('data-prices') || '').split(',').forEach(function (pr) { var a = pr.split(':'); if (a[1]) map[a[0]] = Number(a[1]); });
    var qEl = form.querySelector('[name="quantity"]'), q = Math.max(1, parseInt(qEl && qEl.value, 10) || 1);
    return { vid: vid, unit: map[vid] || map[el.getAttribute('data-variant')] || 0, qty: q };
  }
  function pdpRefresh(fresh) {
    var els = document.querySelectorAll('[data-ctx-approve-pdp]');
    if (!els.length) return;
    cartJs(fresh).then(function (cart) {
      els.forEach(function (el) {
        var it = pdpItem(el), lines = cart.items || [];
        var others = lines.filter(function (i) { return String(i.variant_id) !== it.vid; }).reduce(function (t, i) { return t + i.final_line_price; }, 0);
        var total = others + it.unit * it.qty, ok = total >= MIN;
        el.hidden = !ok;
        /* Never two financing offers at once (Dillon): APPROVE showing hides Shop Pay's instalment line. */
        document.querySelectorAll('form.installment').forEach(function (f) { f.style.display = ok ? 'none' : ''; });
        if (!ok) return;
        var note = el.querySelector('[data-ctx-approve-note]'); if (note) note.textContent = others > 0 ? 'with your cart' : '';
        fill(el, total);
        preload();
      });
    });
  }

  /* ── open the application with the cart (and, on a product page, this item) attached ── */
  function apply(btn) {
    if (btn) btn.setAttribute('aria-busy', 'true');
    var withCart = !btn || !btn.hasAttribute('data-ctx-approve-empty');
    Promise.all([plugin(), withCart ? cartJs(true) : null]).then(function (res) {
      var ar = res[0], cart = res[1];
      var drawer = document.querySelector('cart-drawer'); if (drawer && typeof drawer.close === 'function' && drawer.classList.contains('active')) drawer.close();
      try { ar.clearCart(); } catch (e) {}
      var items = ((cart && cart.items) || []).map(function (i) {
        return { vid: String(i.variant_id), model: i.product_title + (i.variant_title ? ' - ' + i.variant_title : ''), price: Math.round(i.final_line_price / i.quantity) / 100, qty: i.quantity,
          type: /built/i.test(i.vendor || '') ? 'new_product' : 'refurbished_product' };
      });
      var pdp = btn && btn.hasAttribute('data-ctx-approve-with-item') && btn.closest('[data-ctx-approve-pdp]');
      if (pdp) {
        /* The item being viewed joins at the quantity picked, replacing its own cart line if it has one. */
        var it = pdpItem(pdp);
        items = items.filter(function (x) { return x.vid !== it.vid; });
        if (it.unit) items.push({ model: pdp.getAttribute('data-title'), price: it.unit / 100, qty: it.qty, type: /built/i.test(pdp.getAttribute('data-vendor') || '') ? 'new_product' : 'refurbished_product' });
      }
      if (items.length) ar.addItem(items.map(function (x) { return { model: x.model, price: x.price, qty: x.qty, type: x.type }; }));
      try { ar.openSidebar(); } catch (e) {}
      send({ action: 'opened', total_cents: items.reduce(function (t, x) { return t + Math.round(x.price * 100) * x.qty; }, 0), from: pdp ? 'pdp' : 'cart' });
    }).catch(function () {
      /* Plugin unreachable: APPROVE's hosted application still works. */
      location.href = C.landing;
    }).then(function () { if (btn) btn.removeAttribute('aria-busy'); });
  }

  /* ── show / fill the cart lines ── */
  var queued = false;
  function refresh() {
    queued = false;
    var lines = document.querySelectorAll('[data-ctx-approve]');
    if (!lines.length) return;
    var shown = 0;
    lines.forEach(function (el) { var t = Number(el.getAttribute('data-total')), ok = eligible(t); el.hidden = !ok; if (ok) { shown++; fill(el, t); lsSet('ctxBiz', '1'); } });
    if (shown) preload();
  }
  function queue() { if (!queued) { queued = true; setTimeout(function () { refresh(); pdpRefresh(); }, 60); } }
  function markBusiness() { lsSet('ctxBiz', '1'); queue(); }

  var pdpT = null;
  function pdpSoon(fresh, ms) {
    if (!document.querySelector('[data-ctx-approve-pdp]')) return;
    clearTimeout(pdpT); pdpT = setTimeout(function () { pdpRefresh(fresh); }, ms || 150);
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-ctx-approve-apply]');
    if (b) { e.preventDefault(); apply(b); return; }
    pdpSoon(false, 250); /* the quantity buttons set the value without firing an event */
  });
  document.addEventListener('change', function () { pdpSoon(false); });
  document.addEventListener('input', function () { pdpSoon(false); });
  /* Added to cart from the product page: re-read the cart once it has settled. */
  document.addEventListener('submit', function (e) { if (e.target.querySelector && e.target.querySelector('[name="id"]')) pdpSoon(true, 1800); });

  /* Commercial financing page and anything else that opts in: warm the plugin so Apply is instant. */
  function boot() {
    refresh(); pdpRefresh();
    if (/^\/cart\b/.test(location.pathname) || lsGet('ctxBizPage') === '1' || C.biz) markSoon(900);
    var drawer = document.querySelector('cart-drawer');
    if (drawer) new MutationObserver(function () { markSoon(1500); }).observe(drawer, { childList: true, subtree: true });
    if (document.querySelector('[data-ctx-approve-preload], approve-finance-module')) preload();
    new MutationObserver(function (ms) {
      for (var i = 0; i < ms.length; i++) if (ms[i].addedNodes.length) { if (document.querySelector('[data-ctx-approve]')) queue(); return; }
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  window.ctxApprove = { eligible: eligible, markBusiness: markBusiness, apply: apply, refresh: queue, isBusiness: isBiz, signals: signals };
})();
